import React from 'react';
 function Tab(props) {
    return <></>;
}

export default Tab;
